<div class="page-logo">
  <a href="/" class="page-logo-link no-underline flex align-items-center" data-toggle="modal">
    <img src="assets/logo.svg" alt="logo" aria-roledescription="logo" />
  </a>
</div>
<div class="sidebar-menu">
  @for (item of menuConfig; track item) {
    @if (item.router) {
      <div class="sidebar-menu__item" [routerLink]="item.router" routerLinkActive="sidebar-menu__item--active">
        <p class="flex align-items-center">
          <span
            [class.custom-icon]="!item.icon.includes('pi')"
            [ngClass]="item.icon"
            class="sidebar-menu__icon mr-2"
          ></span>
          <span>{{ item.display }}</span>
        </p>
      </div>
    } @else {
      <div
        class="sidebar-menu__item sidebar-menu__item--icons sidebar-menu__item--toogle"
        [class.sidebar-menu__item--active]="item.isOpen"
        (click)="item.isOpen = !item.isOpen"
      >
        <p class="flex align-items-center">
          <span
            [class.custom-icon]="!item.icon.includes('pi')"
            [ngClass]="item.icon"
            class="sidebar-menu__icon mr-2"
          ></span
          >{{ item.display }}
          <span class="angle"><i class="pi pi-angle-down" style="font-size: 1rem"></i></span>
        </p>
      </div>
      <div class="sub-menu__togle-items sub-menu__togle-items--level-one" [class.active]="item.isOpen">
        @for (subMenuItem of item.subMenu; track subMenuItem) {
          @if (subMenuItem.router) {
            <div
              class="sidebar-menu__item"
              [routerLink]="subMenuItem.router"
              routerLinkActive="sidebar-menu__item--active"
            >
              <p>{{ subMenuItem.display }}</p>
            </div>
          } @else {
            <div
              class="sidebar-menu__item sidebar-menu__item--icons sidebar-menu__item--toogle"
              [class.sidebar-menu__item--active]="subMenuItem.isOpen"
              (click)="subMenuItem.isOpen = !subMenuItem.isOpen"
            >
              <p class="flex align-items-center">
                {{ subMenuItem.display }} <span><i class="pi pi-angle-down" style="font-size: 1rem"></i></span>
              </p>
            </div>

            <div class="sub-menu__togle-items sub-menu__togle-items--level-two" [class.active]="subMenuItem.isOpen">
              <div
                *ngFor="let item of subMenuItem?.subMenu"
                class="sidebar-menu__item"
                [routerLink]="item.router"
                routerLinkActive="sidebar-menu__item--active"
              >
                <p>{{ item.display }}</p>
              </div>
            </div>
          }
        }
      </div>
    }
  }
</div>
